import { render, staticRenderFns } from "./NavTasks.vue?vue&type=template&id=bd840c6e&"
import script from "./NavTasks.vue?vue&type=script&lang=js&"
export * from "./NavTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports